<template>
  <div class="oznam" v-if="show">
    <marquee>
      {{ text }}
    </marquee>
  </div>
</template>

<style>
.oznam {
  background:#dc3545;
  color: white;
  line-height: 1;
  padding: 1rem 0;
}
.oznam a {
    color: white;
}
</style>

<script>
export default {
  data() {
    return {
      today: new Date(),
      info: null,
      to: null,
      from: null,
      text: null,
    };
  },
  async mounted() {
    let infoData = (await this.$axios.get("/data/info.json")).data
    this.to = new Date(infoData.oznam.to);
    this.from = new Date(infoData.oznam.from);
    this.text = infoData.oznam.text.replace(":from", this.dateToSkString(this.from)).replace(":to", this.dateToSkString(this.to))

  },
  computed: {
      show : function () {
        return this.today < this.to && this.text != null;
      }
  },
  methods: {
    dateToSkString(date) {
      if (date === undefined || date instanceof Date == false) return "";

      var options = { year: 'numeric', month: 'long', day: 'numeric' };

      return date.toLocaleDateString("sk-SK", options);
    }
  }
};
</script>